// packages/i18n/src/messages/index.ts 에 정의되어있는 내용과 중복이지만
// 거기서 가져오게 되면 패키지 순환참조가 발생함
// TODO: removeLocalePathname 및 여기에 의존하는 utils 모듈들을 features로 옮긴 다음 locales 중복 제거하기
const locales = ['en', 'vi', 'zh-CN', 'zh-TW', 'ru'] as const;

export function removeLocalePathname(pathname: string): string {
  const regex = new RegExp(`^/(${locales.join('|')})(/|$)`);
  return pathname.replace(regex, '/');
}
